import { AgGridTable, type AgGridTableProps } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { Mismatch } from '../../models';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

interface MismatchesAgGridTableProps {
    mismatches: Mismatch[];
    columnDefs: ColDef<Mismatch>[];
    isLoading?: boolean;
    sorting?: SortingConfig | null;
    onSortingChange?: (sorting: SortingConfig | null) => void;
    // Props para scroll infinito
    fetchNextPage?: () => void;
    hasNextPage?: boolean;
    isFetchingNextPage?: boolean;
}

export const MismatchesAgGridTable = ({
    mismatches,
    columnDefs,
    isLoading = false,
    sorting,
    onSortingChange,
    fetchNextPage,
    hasNextPage = false,
    isFetchingNextPage = false,
}: MismatchesAgGridTableProps) => {
    // 🎯 Configuración personalizada para usar order_id como identificador único
    const gridOptions = useMemo(() => ({
        getRowId: (params: any) => String(params.data?.order_id ?? params.data?.ref ?? Math.random()),
    }), []);

    return (
        <div className="w-full">
            <AgGridTable
                data={mismatches}
                columnDefs={columnDefs}
                className="rounded-lg shadow-sm"
                height={
                    mismatches.length <= 10
                        ? `${Math.max(mismatches.length * 70 + 120, 260)}px`
                        : 'calc(100vh - 150px)'
                }
                rowHeight={50}
                enableSelection={false}
                isLoading={isLoading}
                sorting={sorting}
                onSortingChange={onSortingChange}
                fetchNextPage={fetchNextPage}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                gridOptions={gridOptions}
                suppressCellFocus={true}
            />
        </div>
    );
};
